<template>
    <b-tab title-link-class="p-0">
        <template v-slot:title>
            <b-nav name="tab-declined">
                <b-nav-item @click="displayList()">
                    <i class="cus-page-delete"></i>
                    Declined ({{ tabCount }})
                </b-nav-item>
            </b-nav>
        </template>
        <b-card-text>
            <declined-list
                ref="declinedList"
                :key="keyview"
                v-on="$listeners"
            />
        </b-card-text>
    </b-tab>
</template>

<script>
import DeclinedList from "@/components/invoice-declined/declined-list";

export default {
    components: {
        DeclinedList
    },
    data() {
        return {
            keyview: 0
        };
    },
    props: {
        tabCount: {
            type: Number,
            default: 0
        }
    },
    methods: {
        displayList() {
            this.keyview += 1;
            this.$root.$emit("reload-count", 5);
        },
        reloadRefunds() {
            // Render getCash when the cashList already rendered
            // if (this.$refs.cashList) {
            //     this.$refs.cashList.getOrders();
            // }
        }
    }
};
</script>
